export default __webpack_public_path__ + "static/thumb-landscape-c899a447be9c91c9fd1b6fba22e66eb7.webp";